<div class="absolute bottom-0 w-full h-64 overflow-hidden -z-50">
    <div class="absolute h-64 -translate-x-1/2 bg-top bg-no-repeat bg-cover w-400 bg-bottom-image left-1/2"></div>
</div>
